import ReactGA from 'react-ga4';

export const initGA = () => {
  ReactGA.initialize('G-YGF2RC2DRZ', { debug: true });
};

export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};
